import { render, staticRenderFns } from "./errors.vue?vue&type=template&id=5082e80a&"
import script from "./errors.vue?vue&type=script&lang=js&"
export * from "./errors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5082e80a')) {
      api.createRecord('5082e80a', component.options)
    } else {
      api.reload('5082e80a', component.options)
    }
    module.hot.accept("./errors.vue?vue&type=template&id=5082e80a&", function () {
      api.rerender('5082e80a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/errors.vue"
export default component.exports